module.exports = __webpack_public_path__ + "img/fortune-vieyra-QIMjYJSFoXM-unsplash_adobespark.038c55d1.png";